import React, { useState } from 'react';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import Toast from 'react-native-toast-message';
import { crmService } from '../../../services/central-api/crm';
import { ClientError } from '../../../services/central-api/base-service';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import BasicModal from '../../../components/BasicModal';
import { faDiamondExclamation, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import FontWeight from '../../../styles/font-weights';
import { TranslateRich } from '../../../components/TranslateRich';

interface ModalProps {
    cameraData: { id?: string; title: string; disabledAt: Date | null; };
    setDisabledAt: (value: Date | null) => void;
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
}

export default function DisableEnableModal({ cameraData, setDisabledAt, isModalVisible, setModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    const [description, setDescription] = useState('');

    function isDescriptionInvalid(value: string) {
        return value == '';
    }

    async function formSubmit() {
        try {
            if (cameraData?.id) {
                const camera = await crmService.disableEnableCamera(cameraData.id, cameraData.disabledAt !== null ? 'enable' : 'disable', description);
                setDisabledAt(camera.disabledAt);
            }
            setDescription('');
            Toast.show({ type: 'sentinelxSuccess', text1: translate('ActionSuccessfully') });
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            type={cameraData.disabledAt ? 'warning' : 'destructive'}
            title={translate(cameraData.disabledAt ? 'enableCamera' : 'disableCamera')}
            width='small'
            mobileHeight='fit'
            titleIcon={cameraData.disabledAt ? faTriangleExclamation : faDiamondExclamation}
            primaryButton={{
                onClick: formSubmit,
                text: translate(cameraData.disabledAt ? 'enableCamera' : 'disableCamera'),
                disabled: isDescriptionInvalid(description),
            }}
        >
            <MyAppText style={styles.description}>
                <TranslateRich
                    i18nKey={cameraData.disabledAt ? 'enableCameraReason' : 'disableCameraReason'}
                    values={{
                        cameraName: <strong>{cameraData.title}</strong>,
                    }}
                />
            </MyAppText>
            <FormInput
                label={translate('reason')}
                placeholder={translate('reason')}
                value={description}
                onChangeText={setDescription}
                invalid={isDescriptionInvalid}
                labelFontSize={14}
                required={true}
                semiBoldLabel
            />
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    description: {
        color: theme.colors.neutral[400],
        fontWeight: FontWeight.medium,
        fontSize: 16,
    },
}));
